import NoDataDisplay from "../../../../components/UI/NoDataDisplay";
import { setTableHeight } from "../../../../functions/setTableHeight";
import { checkValue } from "../../../../functions/checkValue";
import { formatDate } from "../../../../functions/dateTime/formatDate";
import TableHead from "../../../../components/UI/TableUI/TableHead";
import { truncateDesc } from "../../../../functions/truncateDesc";
import { getVisitStatus } from "../../helpers/getComplaintStatus";
import { adminRoles } from "../../../../utils/adminRoles";
import { hasAnyRole } from "../../../../utils/tableHeaderConfigh";
import sortDataByDate from "../../../../functions/sorting/sortDataByDate";
import { useSelector } from "react-redux";

export const VisitTableView = ({
  filterVisitHeadList,
  setViewDialogDetails,
}) => {
  const visitData = useSelector((state) => state.data.data);
  const isSorted = useSelector((state) => state.data.isSorted);
  const isDataAvailable = visitData.length > 0;
  const dataList = isSorted
    ? visitData
    : sortDataByDate(visitData, "visitedAt");
  const hasRole = hasAnyRole(adminRoles);

  return (
    <div className={`table-container ${setTableHeight(isDataAvailable)}`}>
      <table className={`table ${!isDataAvailable ? "relative" : ""}`}>
        <tbody>
          <TableHead headList={filterVisitHeadList} />
          {isDataAvailable ? (
            <>
              {dataList.map((data, index) => {
                return (
                  <tr className="table-row" key={index}>
                    <td className="text-left">
                      <p className="w-[7rem] whitespace-normal">
                        {data.station.name}
                      </p>
                      <p className="text-xs lg:text-sm text-gray-400 font-normal">
                        SITE ID-{data.station.id}
                      </p>
                    </td>
                    <td> {checkValue(data.station?.machine?.id)}</td>
                    <td>{checkValue(data.operatorPhoneNumber)}</td>
                    <td>{formatDate(data.visitedAt)}</td>
                    <td>{data.fieldTechnician.fullName}</td>
                    {hasRole && <td>{data.supervisor.fullName}</td>}
                    <td>
                      {data.category.name}{" "}
                      {data.category.name === "Complaint" &&
                        ` (${data.category.id})`}
                    </td>
                    <td className="w-72">{truncateDesc(data.workDone)}</td>
                    <td
                      className={`status-data ${
                        getVisitStatus(data.status).textColor
                      }`}
                    >
                      {getVisitStatus(data.status).status}
                    </td>
                    <td>
                      <button
                        className="tableViewBtn"
                        onClick={() =>
                          setViewDialogDetails({ open: true, data: data })
                        }
                      >
                        View
                      </button>
                    </td>
                  </tr>
                );
              })}
            </>
          ) : (
            <NoDataDisplay />
          )}
        </tbody>
      </table>
    </div>
  );
};

export default VisitTableView;
